<template>
  <div class="mobile-navigation">
    <q-layout-header id="mobile-navigation">
      <q-toolbar class="navigation" color="brand">
        <router-link class="logo" :to="{ name: 'projects' }">
          <logo />
        </router-link>
        <div v-if="compressed" class="navigation--compressed">
          <div class="right-align">
            <div
              v-if="compressedUnpublishedChanges > 0"
              class="unpublished-changes"
            >
              {{ $t("ui.drag_editor.unpublished_changes") }}
            </div>
            <add-button />
          </div>
        </div>
        <q-btn @click="drawer = !drawer" flat round dense icon="menu" />
      </q-toolbar>
    </q-layout-header>

    <!-- Mobile drawer menu-->
    <q-layout-drawer
      v-model="drawer"
      side="right"
      :content-style="{ fontSize: '16px', backgroundColor: '#212736' }"
    >
      <q-list-header>
        <router-link class="logo" :to="{ name: 'projects' }">
          <logo />
        </router-link>
      </q-list-header>
      <q-tabs color="brand">
        <!-- Main navigation -->
        <q-route-tab
          is="authenticated-navigation-item"
          exact
          slot="title"
          v-for="routes in mobileNavigation"
          :key="routes.label"
          v-can="routes.credential"
          :bindings="getBindings(routes)"
          :auth="routes.auth"
          :label="routes.label"
          v-on:click.native="onClick()"
          @close="close()"
        />
        <a :href="businessKitLink()" target="_blank">
          <q-tab>Businesskits</q-tab>
        </a>
        <hr />
        <q-route-tab
          :to="{ name: 'user_profile', params: { id: userId } }"
          :label="$t('ui.menu.profile')"
        />
      </q-tabs>
      <!-- Account -->
      <q-tabs color="brand" v-if="userId">
        <q-route-tab
          is="authenticated-navigation-item"
          exact
          slot="title"
          v-for="routes in account"
          :key="routes.label"
          v-can="routes.credential"
          :bindings="getBindings(routes)"
          :auth="routes.auth"
          :label="routes.label"
        />
        <q-tab>
          <language-switcher />
        </q-tab>
      </q-tabs>
    </q-layout-drawer>
  </div>
</template>

<script>
import Logo from "@/components/layouts/partials/Logo";
import AuthenticatedNavigationItem from "@/components/layouts/partials/AuthenticatedNavigationItem";
import LanguageSwitcher from "@/components/layouts/partials/LanguageSwitcher.vue";
import AddButton from "@/components/layouts/partials/AddButton.vue";

export default {
  name: "mobile-navigation",
  components: {
    Logo,
    LanguageSwitcher,
    AuthenticatedNavigationItem,
    AddButton
  },
  data() {
    return {
      LanguageSwitcher,
      drawer: false
    };
  },
  computed: {
    compressed() {
      return this.$store.getters.getHeaderState.compressed;
    },
    compressedUnpublishedChanges() {
      // Right now only works for DragNDropEditor but can be made to use anything
      return this.$store.getters.getDragEditorUnpublishedChanges;
    },
    compressedTitle() {
      let pageTitle = this.$store.state.page_title;
      if (pageTitle.params) {
        return this.$t(pageTitle.label, pageTitle.params);
      } else {
        return this.$t(pageTitle.label);
      }
    },
    userId() {
      return this.$store.getters.currentUser.id;
    },
    mobileNavigation() {
      return [
        {
          label: "dashboard",
          page: {
            name: "dashboard"
          },
          credential: "dashboard.list"
        },
        {
          label: "projects",
          page: {
            name: "projects"
          },
          credential: "projects.list"
        },
        {
          label: "contacts",
          page: {
            name: "contacts"
          },
          credential: "contacts.list"
        },
        {
          label: "segments",
          page: {
            name: "segments"
          },
          credential: "segments.list"
        },
        {
          label: "companies",
          page: {
            name: "companies"
          },
          credential: "companies.show"
        },
        {
          label: "users",
          page: {
            name: "users"
          },
          credential: "users.list"
        },
        {
          label: "organizations",
          page: {
            name: "organizations"
          },
          credential: "organizations.list"
        },
        {
          label: "plans",
          page: {
            name: "plans"
          },
          credential: "plans.list"
        },
        {
          label: "external_forms",
          page: {
            name: "external_forms"
          },
          credential: "external_forms.list",
          auth: "allowed_forms"
        },
        {
          label: "lead_masks",
          page: {
            name: "lead_masks"
          },
          credential: "lead_masks.list",
          auth: "allowed_custom_leadsheets"
        },
        {
          label: "workflows",
          page: {
            name: "workflows"
          },
          credential: "workflows.list",
          //auth: "allowed_custom_leadsheets",
          classes: ["dropdown--item"]
        }
      ];
    },
    account() {
      let menu = [
        {
          label: "sync",
          credential: "projects.synchronize",
          auth: "allowed_crm"
        },
        {
          label: "profile",
          credential: "users.me",
          page: {
            name: "user_edit",
            params: {
              id: this.userId
            }
          }
        },
        {
          label: "logout",
          page: {
            name: "logout"
          }
        }
      ];
      return menu;
    }
  },
  methods: {
    getBindings(item) {
      let bindings = {
        to: {},
        class: []
      };
      if (item.page) {
        bindings.to = item.page;
      }
      if (item.classes) {
        bindings.class = item.classes;
      }
      return bindings;
    },
    close() {
      this.drawer = false;
    },
    businessKitLink() {
      let config = this.$store.state.organization_config.eventbaxx_auth_token;
      if (config) {
        return "https://businesskit.fanomena.io/auth_login/" + config.content;
      } else {
        return "https://businesskit.fanomena.io/auth_login/";
      }
    },
    onClick() {
      this.$store.commit("RESET_ALL_PAGES");
      this.close();
    }
  }
};
</script>
<style lang="sass">
@media(max-width: 575px)
  .navigation--compressed
    .btn
      font-size: 13px !important
    .unpublished-changes
      display: none
@media(max-width: 360px)
  .navigation--compressed
    .actions
      display: none !important
</style>

<style lang="sass" scoped>
.disabled
  background-color: transparent !important

#mobile-navigation
  box-shadow: none
  position: fixed
  .bg-brand
    background: $ink-dark
  .q-btn
    box-shadow: none

.q-tabs-bar
  border: 0

.q-tab
  text-transform: none
  font-weight: $font-regular
  font-size: .95em
  min-height: 70px
  padding: 0 32px
  color: $paper-dark
  cursor: pointer

.q-toolbar
  min-height: 70px
  padding-top: 0
  padding-bottom: 0
  display: flex
  justify-content: space-between

.q-list-header
  text-align: center

.q-router-link-active
  background: #373D4A

.navigation--compressed
  display: flex
  width: 100%
  .unpublished-changes
    margin-right: 20px
  .right-align
    display: flex
    align-items: center
    margin-left: auto
    margin-right: 20px

hr
  border-color: $ink-light
  width: 200px

.language-switcher
  z-index: 999999

#mobile-navigation
  .q-toolbar
    min-height: 50px
</style>



// WEBPACK FOOTER //
// MobileNavigation.vue?912e6dd0